import { render, staticRenderFns } from "./generalCTPRO.vue?vue&type=template&id=6a9ec434&scoped=true&"
import script from "./generalCTPRO.vue?vue&type=script&lang=js&"
export * from "./generalCTPRO.vue?vue&type=script&lang=js&"
import style0 from "./generalCTPRO.vue?vue&type=style&index=0&id=6a9ec434&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9ec434",
  null
  
)

export default component.exports